import { Helmet } from "react-helmet";

const CoTraderNoSubscription = () => {
    return (
      <>
      <Helmet>
        <title>Profile | EMAlpha</title>
      </Helmet>
        <div className="w-100 h-100 d-flex justify-content-center flex-column align-items-center">
          <div
            className=" d-flex flex-column w-100 my-2"
            style={{ height: "40px", width: "100%" }}
          ></div>
          <div className="d-flex flex-grow-1 flex-column bg-white rounded-4 rounded-left w-100 h-100 justify-content-center align-items-center">
            <div className="text-center ">
              <p className="alert alert-warning m-0" role="alert">
                You Don't Have Access to CoTrader <br></br>
                Please Contact Admin for more details{" "}
                <a href="mailto:admin@emalpha.com">admin@emalpha.com</a>
              </p>
            </div>
          </div>
        </div>
      </>
    );
  };
  
  export default CoTraderNoSubscription;